module.exports = [
  './ffmpeg', // args[0] is always binary path
  '-nostdin', // Disable interaction mode
];
